// Helper function for multilingual text
export const getText = (language, en, fr, ar) => {
  switch (language) {
    case 'ar': return ar || fr || en;
    case 'fr': return fr || en;
    default: return en;
  }
};

// Static texts for pages (not managed in admin)
export const staticTexts = {
  // Home Page
  home: {
    since: { en: 'Since 1998', fr: 'Depuis 1998', ar: 'منذ 1998' },
    heroTitle1: { en: 'Industrial &', fr: 'Pièces', ar: 'قطع الغيار' },
    heroTitle2: { en: 'Agricultural Parts', fr: 'Industrielles & Agricoles', ar: 'الصناعية والزراعية' },
    heroSubtitle: { 
      en: 'Official distributor of world-class brands for tractors, combine harvesters, and industrial machinery in Algeria.',
      fr: 'Distributeur officiel de marques mondiales pour tracteurs, moissonneuses et machines industrielles en Algérie.',
      ar: 'الموزع الرسمي للعلامات التجارية العالمية للجرارات والحصادات والآلات الصناعية في الجزائر.'
    },
    viewEquipment: { en: 'View Equipment', fr: 'Voir Équipements', ar: 'عرض المعدات' },
    getInTouch: { en: 'Get in Touch', fr: 'Contactez-nous', ar: 'تواصل معنا' },
    aboutUs: { en: 'About Us', fr: 'À Propos', ar: 'من نحن' },
    yourTrusted: { en: 'Your Trusted', fr: 'Votre Partenaire', ar: 'شريكك' },
    partner: { en: 'Partner', fr: 'de Confiance', ar: 'الموثوق' },
    aboutDescription: {
      en: 'SARL AGRO-EQUIPEMENT (SAE) is an Algerian company based in Oran, specializing in agricultural and industrial equipment and spare parts since 1998. We are the official distributor of world-renowned brands including SKF, MAHLE, RIMA, NTN-SNR, and more.',
      fr: 'SARL AGRO-EQUIPEMENT (SAE) est une société algérienne basée à Oran, spécialisée dans les équipements et pièces de rechange agricoles et industrielles depuis 1998. Nous sommes distributeur officiel de marques mondiales dont SKF, MAHLE, RIMA, NTN-SNR.',
      ar: 'شركة أغرو إكيبمنت ذ.م.م (SAE) هي شركة جزائرية مقرها في وهران، متخصصة في المعدات وقطع الغيار الزراعية والصناعية منذ 1998. نحن الموزع الرسمي للعلامات التجارية العالمية بما في ذلك SKF و MAHLE و RIMA و NTN-SNR.'
    },
    discoverServices: { en: 'Discover Our Services', fr: 'Découvrir Nos Services', ar: 'اكتشف خدماتنا' },
    whyChooseUs: { en: 'Why Choose Us', fr: 'Pourquoi Nous Choisir', ar: 'لماذا تختارنا' },
    excellence: { en: 'Excellence in', fr: "L'Excellence", ar: 'التميز في' },
    everyDetail: { en: 'Every Detail', fr: 'dans Chaque Détail', ar: 'كل التفاصيل' },
    ourPartners: { en: 'Our Partners', fr: 'Nos Partenaires', ar: 'شركاؤنا' },
    trustedBy: { en: 'Trusted by', fr: 'La Confiance de', ar: 'موثوق من قبل' },
    industry: { en: 'Industry Leaders', fr: 'Leaders du Secteur', ar: 'رواد الصناعة' },
    viewAllPartners: { en: 'View All Partners', fr: 'Voir Tous les Partenaires', ar: 'عرض جميع الشركاء' },
    readyToWork: { en: 'Ready to Work Together?', fr: 'Prêt à Travailler Ensemble?', ar: 'مستعد للعمل معنا؟' },
    contactTeam: { 
      en: 'Contact our team for personalized assistance with your equipment needs.',
      fr: 'Contactez notre équipe pour une assistance personnalisée selon vos besoins.',
      ar: 'تواصل مع فريقنا للحصول على مساعدة مخصصة لاحتياجاتك من المعدات.'
    },
    contactUs: { en: 'Contact Us', fr: 'Nous Contacter', ar: 'اتصل بنا' }
  },

  // Stats
  stats: {
    years: { en: 'Years Experience', fr: "Ans d'Expérience", ar: 'سنة خبرة' },
    partners: { en: 'Partner Brands', fr: 'Marques Partenaires', ar: 'شريك تجاري' },
    clients: { en: 'Satisfied Clients', fr: 'Clients Satisfaits', ar: 'عميل راضي' }
  },

  // Features
  features: {
    quality: { 
      title: { en: 'Premium Quality', fr: 'Qualité Premium', ar: 'جودة عالية' },
      desc: { en: 'Genuine OEM parts with manufacturer warranty', fr: 'Pièces OEM authentiques avec garantie fabricant', ar: 'قطع غيار أصلية مع ضمان الشركة المصنعة' }
    },
    delivery: { 
      title: { en: 'Fast Delivery', fr: 'Livraison Rapide', ar: 'توصيل سريع' },
      desc: { en: 'Nationwide shipping within 48 hours', fr: 'Livraison nationale sous 48 heures', ar: 'شحن على مستوى البلاد خلال 48 ساعة' }
    },
    service: { 
      title: { en: 'Expert Service', fr: 'Service Expert', ar: 'خدمة متخصصة' },
      desc: { en: 'Technical support and installation assistance', fr: 'Support technique et aide à l\'installation', ar: 'دعم فني ومساعدة في التركيب' }
    },
    support: { 
      title: { en: '24/7 Support', fr: 'Support 24/7', ar: 'دعم على مدار الساعة' },
      desc: { en: 'Always available to assist you', fr: 'Toujours disponible pour vous aider', ar: 'متاحون دائماً لمساعدتك' }
    }
  },

  // Equipment Page
  equipment: {
    title: { en: 'Equipment', fr: 'Équipements', ar: 'المعدات' },
    subtitle: {
      en: 'Discover our wide range of agricultural and industrial equipment',
      fr: 'Découvrez notre large gamme d\'équipements agricoles et industriels',
      ar: 'اكتشف مجموعتنا الواسعة من المعدات الزراعية والصناعية'
    },
    categories: { en: 'Categories', fr: 'Catégories', ar: 'الفئات' },
    images: { en: 'images', fr: 'images', ar: 'صور' },
    ourProducts: { en: 'Our Products', fr: 'Nos Produits', ar: 'منتجاتنا' },
    qualityAssurance: { en: 'Quality Assurance', fr: 'Assurance Qualité', ar: 'ضمان الجودة' },
    originalParts: { en: 'Original Parts', fr: 'Pièces Originales', ar: 'قطع أصلية' },
    guaranteedQuality: { en: 'Guaranteed Quality', fr: 'Qualité Garantie', ar: 'جودة مضمونة' },
    qualityDescription: {
      en: 'Systematic use of ORIGINAL parts optimizes the safety of CLAAS machines. Our spare parts are series parts that are perfectly adapted and of high quality, from a modern manufacturing process and subject to permanent quality controls.',
      fr: 'Une utilisation systématique de pièces ORIGINALES permet d\'optimiser la sécurité d\'utilisation des machines. Nos pièces de rechange sont des pièces de série parfaitement adaptées et de haute qualité, issues d\'un processus de fabrication moderne et soumises à des contrôles de qualité permanents.',
      ar: 'يضمن الاستخدام المنهجي للقطع الأصلية سلامة آلات CLAAS. قطع الغيار لدينا هي قطع سلسلة متوافقة تماماً وعالية الجودة، من عملية تصنيع حديثة وتخضع لفحوصات جودة دائمة.'
    },
    view: { en: 'View', fr: 'Voir', ar: 'عرض' },
    noImages: { en: 'No images available', fr: 'Aucune image disponible', ar: 'لا توجد صور متاحة' }
  },

  // Contact Page
  contact: {
    title: { en: 'Contact Us', fr: 'Contactez-nous', ar: 'اتصل بنا' },
    subtitle: {
      en: 'Get in touch with our team',
      fr: 'Entrez en contact avec notre équipe',
      ar: 'تواصل مع فريقنا'
    },
    getInTouch: { en: 'Get in Touch', fr: 'Contactez-Nous', ar: 'تواصل معنا' },
    form: {
      title: { en: 'Send us a Message', fr: 'Envoyez-nous un Message', ar: 'أرسل لنا رسالة' },
      name: { en: 'Your Name', fr: 'Votre Nom', ar: 'اسمك' },
      email: { en: 'Your Email', fr: 'Votre Email', ar: 'بريدك الإلكتروني' },
      subject: { en: 'Subject', fr: 'Sujet', ar: 'الموضوع' },
      message: { en: 'Message', fr: 'Message', ar: 'الرسالة' },
      send: { en: 'Send Message', fr: 'Envoyer', ar: 'إرسال' },
      sending: { en: 'Sending...', fr: 'Envoi en cours...', ar: 'جاري الإرسال...' },
      success: { en: 'Your message has been sent!', fr: 'Votre message a été envoyé!', ar: 'تم إرسال رسالتك!' },
      error: { en: 'Failed to send message. Please try again.', fr: 'Échec de l\'envoi. Veuillez réessayer.', ar: 'فشل إرسال الرسالة. حاول مرة أخرى.' }
    }
  },

  // Services Page
  services: {
    title: { en: 'Our Services', fr: 'Nos Services', ar: 'خدماتنا' },
    subtitle: {
      en: 'Professional solutions for your equipment needs',
      fr: 'Solutions professionnelles pour vos besoins en équipements',
      ar: 'حلول احترافية لاحتياجاتك من المعدات'
    },
    whatWeOffer: { en: 'What We Offer', fr: 'Ce Que Nous Offrons', ar: 'ما نقدمه' },
    ourCommitment: { en: 'Our Commitment', fr: 'Notre Engagement', ar: 'التزامنا' },
    quality: { en: 'Quality &', fr: 'Qualité &', ar: 'الجودة و' },
    excellence: { en: 'Excellence', fr: 'Excellence', ar: 'التميز' },
    qualityDescription: {
      en: 'To preserve our competitiveness in the market and better satisfy our customers, we offer them leading brands in the field that develop cutting-edge technology in their techniques and engineering.',
      fr: 'Afin de préserver notre compétitivité sur le marché et mieux satisfaire nos clients, nous leurs offrons des marques leader dans le domaine qui développent une technologie de pointe dans leurs techniques et d\'ingénierie.',
      ar: 'للحفاظ على تنافسيتنا في السوق وإرضاء عملائنا بشكل أفضل، نقدم لهم علامات تجارية رائدة في المجال تطور تكنولوجيا متطورة في تقنياتها وهندستها.'
    },
    years: { en: 'Years', fr: 'Années', ar: 'سنة' },
    partnersCount: { en: 'Partners', fr: 'Partenaires', ar: 'شريك' },
    coverage: { en: 'Coverage', fr: 'Couverture', ar: 'تغطية' }
  },

  // Partners Page
  partners: {
    title: { en: 'Our Partners', fr: 'Nos Partenaires', ar: 'شركاؤنا' },
    subtitle: {
      en: 'We collaborate with world-class brands',
      fr: 'Nous collaborons avec des marques mondiales',
      ar: 'نتعاون مع علامات تجارية عالمية'
    },
    ourNetwork: { en: 'Our Network', fr: 'Notre Réseau', ar: 'شبكتنا' },
    learnMore: { en: 'Learn More', fr: 'En Savoir Plus', ar: 'اعرف المزيد' },
    alsoRepresentative: { en: 'Also Official Representative of', fr: 'Également Représentant Officiel de', ar: 'أيضاً ممثل رسمي لـ' },
    becomePartner: { en: 'Become a Partner', fr: 'Devenir Partenaire', ar: 'كن شريكاً' },
    joinNetwork: {
      en: 'Join our network and grow your business with world-class products',
      fr: 'Rejoignez notre réseau et développez votre entreprise avec des produits de classe mondiale',
      ar: 'انضم إلى شبكتنا وطور أعمالك مع منتجات عالمية المستوى'
    }
  },

  // References Page
  references: {
    title: { en: 'Our References', fr: 'Nos Références', ar: 'مراجعنا' },
    subtitle: {
      en: 'Trusted by leading companies in Algeria',
      fr: 'La confiance des entreprises leaders en Algérie',
      ar: 'موثوق من قبل الشركات الرائدة في الجزائر'
    },
    trustedClients: { en: 'Trusted Clients', fr: 'Clients de Confiance', ar: 'عملاء موثوقون' }
  },

  // Events Page
  events: {
    title: { en: 'Events', fr: 'Événements', ar: 'الفعاليات' },
    noEvents: { 
      en: 'No events scheduled at the moment',
      fr: 'Aucun événement prévu pour le moment',
      ar: 'لا توجد فعاليات مجدولة حالياً'
    },
    upcomingEvents: { en: 'Upcoming Events', fr: 'Événements à Venir', ar: 'الفعاليات القادمة' }
  },

  // Common
  common: {
    learnMore: { en: 'Learn More', fr: 'En Savoir Plus', ar: 'اعرف المزيد' },
    viewAll: { en: 'View All', fr: 'Voir Tout', ar: 'عرض الكل' },
    loading: { en: 'Loading...', fr: 'Chargement...', ar: 'جاري التحميل...' },
    error: { en: 'An error occurred', fr: 'Une erreur est survenue', ar: 'حدث خطأ' },
    backToHome: { en: 'Back to Home', fr: 'Retour à l\'accueil', ar: 'العودة للرئيسية' },
    readMore: { en: 'Read More', fr: 'Lire Plus', ar: 'اقرأ المزيد' }
  }
};

// Get text by path (e.g., 'home.since')
export const getStaticText = (language, path) => {
  const keys = path.split('.');
  let value = staticTexts;
  for (const key of keys) {
    value = value?.[key];
  }
  if (value && typeof value === 'object') {
    return value[language] || value.fr || value.en;
  }
  return path;
};
